import React, { useState, useRef } from "react";
import "./Circle.scss";

// The JSON for this component uses array indexes to implement the connections between circles. Because of this, reordering elements in the JSON will cause the data to become invalid. Below is the quick fix used to reorder the elements while preserving the connections

// -----------------------------------------

// a.chapters[0].segments[1].container.map(circle => {
//   circle.relations = circle.relations.map( (i) =>  a.chapters[0].segments[1].container[i].order)
//   return circle
// })

// a.chapters[0].segments[1].container.sort((a,b) => {return a.order-b.order})

// console.log(JSON.stringify(a,null,'  '))

// -----------------------------------------



const Circle = ({ circles, selectedCircleId, secondSelectedCircleId, circleClicked, title, visitedCircleRelations }) => {
  // const [selectedCircleId, setSelectedCircleId] = useState(-1);
  const container = useRef(null);
  const selectedCircle = circles[selectedCircleId];
  const secondSelectedCircle = circles[secondSelectedCircleId]
  const circlePosition = [300,250];
  const circleRadius = 175;
  const dotRadius = 30;
  const radiansPerDegree = 0.017453292519943295;
  const circleCoords = circles.map((circle, i) => {
    const angle = ((i + 1.5) /( circles.length + 2)) * 360 * radiansPerDegree;
    return [circlePosition[0] + Math.cos(angle) * circleRadius, circlePosition[1] + Math.sin(angle) * circleRadius ]
  });

  // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/d#path_commands
  const getSvgPathCommandsForCurve = (start, end) => {
    const toCenter = [circlePosition[0] - start[0], circlePosition[1] - start[1]]
    return `M ${start[0]},${start[1]} S ${start[0] + (toCenter[0] * 0.75)},${start[1] + (toCenter[1] * 0.75)} ${end[0]},${end[1]}` 
  }

  const svgStyle = {
    transition: "border 0.2s ease-in-out",
  };

  const [circleCheckBoxDisp, SetCircleCheckBoxDisp]=useState([]);

  circles.length>=circleCheckBoxDisp && SetCircleCheckBoxDisp(circles.map(Cir=> {  return {
  // ...circleCheckBoxDisp,
  id: Cir.id,
  status: false
}
}))

  // SetCircleCheckBoxDisp(push(id:))

  return (
    <div ref={container}>
      {container != null && (<>
        <div className='mission-elements-foreground'>
          {console.log(circleCheckBoxDisp,"circleCheckBoxDisp")}
          <h2 className={`title-container ${selectedCircle ? 'selected-circle-header' : ''}`}>{title}</h2>
          {circleCoords.map(([x, y], i) => (      
              <button className="circle-header" onClick={() => circleClicked(circles[i])} style={{left:`calc(-2.75em + ${x}px)`, top:`${y}px`}}
              >
                <div>{circles && circles[i] ? circles[i].heading : null}</div>
              </button>
          ))}
        </div>
        <svg className='mission-elements-background' width="500" height="100%" viewBox="0 0 500 500">
          {selectedCircle && selectedCircle.relations.map((relation, key) => {
            return (
              <path
                key={key}
                d={getSvgPathCommandsForCurve(circleCoords[selectedCircleId], circleCoords[relation.circleId])}
                fill="transparent"
                stroke={selectedCircle ? selectedCircle.color : "#8b8b8b"}
                opacity={secondSelectedCircleId === relation.circleId ? 5 : .4}
                strokeWidth="3"
              />
            );
          })}
          {circleCoords.map(([x, y], i) => (
            <g key={i}>
              <circle
                style={svgStyle}
                cx={x}
                cy={y}
                r={(dotRadius * 14.5 /15.5)}
                // if selectedCircle && this circle can be found in selecteedCircle.relations ? selectedCircle.color : "#8b8b8b"
                stroke={(i === secondSelectedCircleId) ? selectedCircle.color : "#78a1bb"}
                strokeWidth="2"
                fill="none"
              />
              {(i === selectedCircleId || selectedCircle && selectedCircle.relations.find((relation) => relation.circleId === i)) && <circle
                cx={x}
                cy={y}
                r={dotRadius}
                fill={circles[i].color}
                
              />}
              {(i === selectedCircleId) &&visitedCircleRelations[i].map((c,index)=> {if(c==true){
                if(index===visitedCircleRelations[i].length-1){
                //   circleCheckBoxDisp.map( qo =>  {
                //     if (qo.id  === i) {
                //         return {
                //             ...qo,
                //             status: true,
                //         }
                //     }
                // }
                //   )
                {console.log(c,"ckck123123if",index)}
              }else{
                {console.log(c,"ckck123123else",index)}
              }
            }
          }
            )
          }
            </g>
          ))}
        </svg>
      </>)}
    </div>
  );
};
export default Circle;
